import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductInfoGetDtoResponse } from "../models/product/dto/info/product-info-get-response";
import { ProductInfoPutRequest } from "../models/product/dto/info/product-info-put-request";

import { EnvironmentService } from "./environment.service";
import { switchMap } from "rxjs/internal/operators/switchMap";

@Injectable({
  providedIn: 'root'
})
export class ProductInfoService {
  fullPath: string;
  constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {    
    this.fullPath = `${envService.settings.apiUrl}/products`;
  }

  public get(id: string): Observable<ProductInfoGetDtoResponse> {
    return this.httpClient.get<ProductInfoGetDtoResponse>(`${this.fullPath}/${id}/info`);
  }

  public update(model: ProductInfoPutRequest): Observable<ProductInfoPutRequest> {
    return this.httpClient.put<ProductInfoPutRequest>(`${this.fullPath}/${model.id}/info`, model);
  }
}
